/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Paywall_ErrorInputs */

const en_mobile_paywall_error = /** @type {(inputs: Mobile_Paywall_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again.`)
};

const es_mobile_paywall_error = /** @type {(inputs: Mobile_Paywall_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Something went wrong. Please try again." |
*
* @param {Mobile_Paywall_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_paywall_error = /** @type {((inputs?: Mobile_Paywall_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Paywall_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_paywall_error(inputs)
	return en_mobile_paywall_error(inputs)
});